<template>
  <b-modal 
    v-model="showModal"
    ok-title="Add Users"
    cancel-title="Remind Me Later"
    @ok="submit"
    @cancel="cancel"
    @hide="cancel"
  >
    
    <template v-slot:modal-title>
      <span class="d-flex align-items-center">
        <font-awesome-icon
          :icon="['fa', 'cogs']"
          size="2x"
          class="wizard__icon mr-3">
        </font-awesome-icon>
        <span class="d-inline-block pt-1">Project Setup: Add Team Members</span>
      </span>
      
    </template>
    Welcome to the {{ projectName }} dashboard. Invite team members to get started.
  </b-modal>
</template>

<script>
export default {
  props: {
    projectId: { type: String, required: true },
    projectName: { type: String, required: true },
  },
  data() {
    return {
      showModal: false
    };
  },
  mounted() {
    this.show();
  },
  methods: {
    show(){
      this.showModal = true;
    },
    hide(){
      this.showModal = false;
    },
    submit() {
      this.$emit('submit');
    },
    cancel() {
      this.$emit('cancel');
    },
  }
}
</script>